import {
  Accordion,
  Card,
  Checkbox,
  Modal,
  ModalSection,
} from '@monash/portal-react';
import c from './filters-modal.module.scss';
import classNames from 'classnames';
import SubFilterCheckboxes from './sub-filter-checkboxes/SubFilterCheckboxes';
import { LINKS_FILTER_OPTIONS } from '../constants';
import { isObject } from '@monash/portal-frontend-common';

const FiltersModal = ({
  open,
  onClose,
  filtersFields,
  appendFilter,
  removeFilter,
}) => {
  const toggleCheckbox = ({ isChecked, value, index }) => {
    isChecked ? removeFilter(index) : appendFilter({ value });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalSection title="Filters">
        <div>
          <Accordion
            useCustomStyles
            className={c.filtersAccordion}
            stylesheet={c}
            hasExpandAll={false}
            items={Object.values(LINKS_FILTER_OPTIONS).map((filter) => {
              const { value, text, prefix, subFilters } = filter;

              const index = filtersFields.findIndex(
                (filter) => filter.value === value
              );

              const isChecked = index !== -1;

              const someSubFilterIsChecked =
                isObject(subFilters) &&
                filtersFields.some((filter) =>
                  Object.values(subFilters)
                    .map(({ value }) => value)
                    .includes(filter.value)
                );

              return {
                title: prefix,
                content: (
                  <div className={c.subsection}>
                    <Card
                      className={classNames(c.subsectionCard, {
                        [c.disabled]: someSubFilterIsChecked, // disabled if any sub filters are checked
                      })}
                    >
                      <Checkbox
                        text={text}
                        on={isChecked}
                        onChange={() =>
                          toggleCheckbox({ isChecked, value, index })
                        }
                        disabled={someSubFilterIsChecked}
                      />
                    </Card>
                    {subFilters && (
                      <Card
                        className={classNames(c.subsectionCard, {
                          [c.disabled]: isChecked, // disabled if parent filter is checked
                        })}
                      >
                        <SubFilterCheckboxes
                          subFilters={subFilters}
                          isParentChecked={isChecked}
                          filtersFields={filtersFields}
                          appendFilter={appendFilter}
                          removeFilter={removeFilter}
                          toggleCheckbox={toggleCheckbox}
                        />
                      </Card>
                    )}
                  </div>
                ),
              };
            })}
          />
        </div>
      </ModalSection>
    </Modal>
  );
};

export default FiltersModal;
